// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"c41a2e72","140":"90b04dbc","174":"48bb0771","198":"bce2b145","205":"34d10b67","237":"a51c0cd9","286":"c3e17db8","488":"1f95b7a8","612":"225fe996","741":"e9d5820b","793":"b7e1f216","796":"6781f577","819":"0e3c013d","882":"2d855824","957":"6c61e91e","990":"48768a9b"}[chunkId] + ".chunk.js";
};